<template>
  <div id="app">
    <Navbar/>

    <router-view class="router-margin"/>
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";

export default {
  name: 'App',
  components: {
    Navbar
  },
}
</script>

<style>
.router-margin {
  padding-top: 65px;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #f7f7f7;
  margin: 0 !important;
  padding: 0 !important;
}
</style>
<style lang="scss">
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #4099FF;

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Placeholder color
$input-placeholder-color: #A0A0A0;
// Row color chen hover
// $table-row-hover-background-color: #A19BAC; 

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>



// WEBPACK FOOTER //
// src/App.vue